import { ChevronLeftIcon } from 'components/icons';

/**
 *
 * @param {{pages:*,currentPage:*,canNextPage:*,canPreviousPage:*,nextPage:*, previousPage:*, gotoPage:*}} param0
 * @returns
 */
export default function Pagination({
  pages,
  currentPage,
  canNextPage,
  canPreviousPage,
  nextPage,
  previousPage,
  gotoPage,
}) {
  return (
    <div className="flex justify-center mt-8">
      <button
        aria-label="Previous page"
        className="flex items-center justify-center w-8 h-8 rounded hover:bg-segments-gray-F1 disabled:pointer-events-none focus:outline-none"
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
      >
        <ChevronLeftIcon className="w-4 h-4" />
      </button>
      {pages?.map((
        // @ts-ignore
        page
      ) => (
        <PaginationNumberTiles
          pageNumber={page + 1}
          selected={page === currentPage}
          gotoPage={gotoPage}
          key={page}
        />
      ))}
      <button
        aria-label="Next page"
        className="flex items-center justify-center w-8 h-8 rounded hover:bg-segments-gray-F1 disabled:pointer-events-none focus:outline-none"
        onClick={() => nextPage()}
        disabled={!canNextPage}
      >
        <ChevronLeftIcon className="w-4 h-4 transform rotate-180" />
      </button>
    </div>
  );
}

/**
 *
 * @param {{pageNumber:*, selected:*, gotoPage:*}} param0
 * @returns
 */
function PaginationNumberTiles({ pageNumber, selected, gotoPage }) {
  return (
    <button
      className={`rounded flex items-center justify-center py-1 px-3 focus:outline-none hover:bg-segments-gray-F1 ${
        selected &&
        'bg-segments-accent-color-1 text-white hover:bg-segments-accent-color-1'
      }`}
      onClick={(e) => {
        // @ts-ignore
        const page = e.target.innerText ? Number(e.target.innerText) - 1 : 0;
        gotoPage(page);
      }}
    >
      {pageNumber}
    </button>
  );
}
